export default "__VITE_ASSET__d231ffcc__"